import { useContext } from 'react';
import CurrentTripsContext, { ProviderContext } from './CurrentTripsContext';

const useCurrentTrips = (): ProviderContext => useContext(CurrentTripsContext)
export default useCurrentTrips;